import { rootDomain } from './root';

export const logout = rootDomain.createEvent();
